/**
 * Frontend configuration (edit here — no .env file required).
 * Must match backend `config.js` Google Web client ID and enabled flag.
 *
 * API_BASE_URL — IIS reverse-proxies /api/* → http://localhost:8001/api/*
 * so use a relative path here. The browser calls the same origin and IIS
 * forwards it internally — no CORS or Private Network Access issues.
 *
 * Change to an absolute URL only if you move the backend off this server.
 */
export const API_BASE_URL = '/api';

export const ENABLE_GOOGLE_LOGIN = true;
export const GOOGLE_CLIENT_ID =
  '399333275485-rj6sh25vt2j2ihfp03l6abobtvdiubpv.apps.googleusercontent.com';
